var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 35.4976C33 34.6692 32.3284 33.9976 31.5 33.9976C30.6716 33.9976 30 34.6692 30 35.4976V37.4976C30 38.326 30.6716 38.9976 31.5 38.9976C32.3284 38.9976 33 38.326 33 37.4976V35.4976Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 28.9976C21.1193 28.9976 20 30.1169 20 31.4976V41.4976C20 42.8783 21.1193 43.9976 22.5 43.9976H40.5C41.8807 43.9976 43 42.8783 43 41.4976V31.4976C43 30.1169 41.8807 28.9976 40.5 28.9976H37V22.4976C37 19.46 34.5376 16.9976 31.5 16.9976C28.4624 16.9976 26 19.46 26 22.4976V28.9976H22.5ZM34 22.4976V28.9976H29V22.4976C29 21.1169 30.1193 19.9976 31.5 19.9976C32.8807 19.9976 34 21.1169 34 22.4976ZM23 40.9976V31.9976H40V40.9976H23Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2383 5.34241C32.5425 4.36893 30.4575 4.36894 28.7617 5.34241L12.7617 14.5276C11.0534 15.5083 10 17.3277 10 19.2975V38.1963C10 44.7792 14.0003 49.7742 18.2966 53.2443C22.61 56.7282 27.459 58.8757 29.7038 59.7644C30.8632 60.2234 32.1368 60.2234 33.2962 59.7644C35.541 58.8758 40.39 56.7282 44.7034 53.2443C48.9997 49.7742 53 44.7792 53 38.1963V19.2975C53 17.3277 51.9466 15.5083 50.2383 14.5276L34.2383 5.34241ZM30.2553 7.94417C31.0261 7.50168 31.9739 7.50168 32.7447 7.94417L48.7447 17.1294C49.5212 17.5751 50 18.4021 50 19.2975V38.1963C50 43.4619 46.8075 47.6885 42.8184 50.9105C38.8463 54.1187 34.3174 56.1336 32.192 56.975C31.742 57.1532 31.258 57.1532 30.808 56.975C28.6826 56.1336 24.1537 54.1187 20.1816 50.9105C16.1925 47.6885 13 43.4619 13 38.1963V19.2975C13 18.4021 13.4788 17.5751 14.2553 17.1294L30.2553 7.94417Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.83ad2bce3cde099565fe24d753936046.svg";
export { ForwardRef as ReactComponent };